'use client'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Suspense, useEffect } from 'react'
import TagManager from 'react-gtm-module'
import CouponFromUrl from '@/components/Cart/CouponFromUrl'
import { Footer } from '@/components/Pages/Footer'
import { Navbar } from '@/components/Shell/Navbar'
import { SessionWatcher } from '@/components/Shell/SessionWatcher'
import SupportStripe from '@/components/Shell/SupportStripe'
import { useAnonymousSession } from '@/hooks/business/auth/useAnonymousSession'
import { usePageVisibilityTitle } from '@/hooks/ui/usePageVisibilityTitle'

const GTM_ID = 'GTM-T49N836'
const WHATSAPP_URL = 'https://wa.me/554135153980?text=Ol%C3%A1!%20preciso%20de%20ajuda.'

/**
 * Parte cliente do layout raiz: sessão anônima, conferência e aviso de sessão expirada (SessionWatcher), barra, faixa de
 * suporte, rodapé, botão do WhatsApp, GTM, cupom da URL e o título "Ei, psiu". Sem provider: o único é o AppProvider do
 * layout raiz.
 */
const ClientShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    usePageVisibilityTitle()
    useAnonymousSession()

    useEffect(() => {
        TagManager.initialize({ gtmId: GTM_ID })
    }, [])

    return (
        <>
            <SessionWatcher />
            <Suspense fallback={null}>
                <CouponFromUrl />
            </Suspense>
            <Navbar />
            <SupportStripe />
            {children}
            <Footer />
            <a
                href={WHATSAPP_URL}
                target="_blank"
                aria-label="Fale conosco pelo WhatsApp"
                className="fixed right-8 bottom-8 text-white text-3xl flex items-center justify-center bg-green-500 w-14 h-14 cursor-pointer rounded-full z-999"
                rel="noopener"
            >
                <FontAwesomeIcon icon={faWhatsapp} />
            </a>
        </>
    )
}

export default ClientShell
